import cloneDeep from 'lodash/cloneDeep';
import {
  FIELD_TYPE_DATE,
  FIELD_TYPE_FULL_NAME,
  FIELD_TYPE_ADDRESS,
} from '@/contants/base';

export async function getList({commit}, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.applications.index(payload);
  commit('setList', errResponse || !responseData.success ? [] : responseData.data.data);
  return responseData;
}

export async function getDetail(_, id) {
  const responseData = await this.$frontendRepositories.applications.show(id);
  return responseData.data;
}

export async function checkCanDownload(_, appUserId) {
  return this.$frontendRepositories.applications.checkCanDownload(appUserId);
}

export async function getListForUser({commit}, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.applications.getListForUser(payload);
  commit('setListForUser', errResponse || !responseData.success ? [] : responseData.data);
  return responseData;
}

export async function getAllForUser({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.applications.getAllForUser();
  commit('setAllAppUser', errResponse || !responseData.success ? [] : responseData.data)

  return responseData
}

export async function checkLimitAppUser({commit}, appId) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.applications.checkLimitAppUser(appId);
  return responseData.data;
}

export async function findApplicationForUser({commit}, idEncrypt) {
  const response = await this.$frontendRepositories.applications.findApplicationForUser(idEncrypt);
  const {errResponse, data: responseData} = response;

  if (!errResponse && responseData) {
    commit('setApplication', cloneDeep(responseData.data.application));
    commit('setAppUser', responseData.data);
  }

  return response;
}

export async function saveAnswer({commit}, payload) {
  const response =  await this.$frontendRepositories.applications.saveAnswer(payload);
  const {errResponse, data: responseData} = response;

  if (!errResponse && responseData) {
    commit('setAppUserState', responseData.data.state);
  }
  return response;
}

export async function setInitValueFromField({commit}, field) {
  switch (field.mst_field.type) {
    case FIELD_TYPE_DATE:
      const style = field.style;
      const format = style.advance.format.split(/[^\w]/).map((key) => key).filter(Boolean);

      return format.reduce((acc, key) => {
        acc[key] = null;

        return acc;
      }, {});
    case FIELD_TYPE_FULL_NAME:
      return {
        firstName_kana: null,
        lastName_kana: null,
        firstName: null,
        lastName: null,
      };
    case FIELD_TYPE_ADDRESS:
      return {
        postCode: null,
        province: null,
        district: null,
        street: null,
        building: null,
        fullAddress: null,
      };
    default:
      return null;
  }
}

// export async function saveAnswer({commit}, payload) {
//   const response = await this.$frontendRepositories.applications.saveAnswer(payload);
//   const {data: responseData} = response;
//   commit('setStateForApplication', responseData.data.state);
//   commit('setAnswerForApplication', responseData.data);
//   return response;
// }

export async function downloadDocFiles(_, idEncrypt) {
  const payload = {
    app_user_id: idEncrypt,
    company_id: this.$cookies.get('workspace')
  }
  return this.$frontendRepositories.applications.downloadDocFiles(payload);
}

export async function handleNext({commit}) {
  // call api
  commit('nextNormalStep');
}


export async function deleteApplicationUser({commit}, id) {
  const response = await this.$frontendRepositories.applications.deleteApplicationUser(id);

  return response;
}

export async function getAddressByPostalCode(_, code) {
  const responseData = await this.$frontendRepositories.applications.getAddressByPostalCode(code);
  return responseData.data;
}

export async function getReceipts({_}) {
  const response = await this.$frontendRepositories.applications.receipt();
  
  return response;
}

export async function findById(_, id) {
  const { errResponse, data: responseData } = await this.$frontendRepositories.applications.findById(id);
  if (!errResponse) {
    return responseData.data
  }

  return {}
}

export async function getTags({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.applications.getTags();
  if (!errResponse) {
    commit('setTags', responseData.data);
  }

  return []
}
